import * as PropTypes from "prop-types";
import classNames from "classnames";
import Waypoint from "react-waypoint";

import imageMapStyles from "./ImageMap.css";

import { withViewport } from "/react/utils/withViewport";

import { ImageMapSlider, Tooltip, Photo } from "/react/library/";

import { IconClose } from "/react/library/Icons";

@withViewport()
export class ImageMap extends React.PureComponent {
  static propTypes = {
    image: PropTypes.object.isRequired,
    markers: PropTypes.array.isRequired,
    activeMarkerId: PropTypes.number,
    isFlightDeck: PropTypes.bool,
  };

  state = {
    activeMarkerId: null,
    isInViewport: false,
  };

  inViewportMargin = "50%";

  photoRef = React.createRef();

  toggleTooltip = (markerId) => {
    if (this.props.viewportIsTabletOrBigger) {
      this.setState({
        activeMarkerId:
          this.state.activeMarkerId === markerId ? null : markerId,
      });
    }
  };

  maybeCloseActiveTooltip = ({ target }) => {
    const clickedOutsideMarker =
      this.photoRef.current &&
      this.photoRef.current.photoRef.current === target;
    if (this.props.viewportIsTabletOrBigger && clickedOutsideMarker) {
      this.setState({ activeMarkerId: null });
    }
  };

  componentDidUpdate(prevProps) {
    if (this.props.activeMarkerId !== prevProps.activeMarkerId) {
      this.setState({ activeMarkerId: prevProps.activeMarkerId });
    }
  }

  componentDidMount() {
    if (this.props.activeMarkerId)
      this.setState({ activeMarkerId: this.props.activeMarkerId });
  }

  handleOnEnter = () => {
    this.setState({
      isInViewport: true,
    });
  };

  handleImageMapSliderChange = (markerId) => {
    this.setState({ activeMarkerId: markerId });
  };

  isActive = (markerId) => this.state.activeMarkerId === markerId;

  getMarkerStyles(markerStyles, index) {
    return {
      ...markerStyles,
      transitionDelay: `${index * 150}ms`,
    };
  }

  render() {
    const { isInViewport } = this.state;
    const {
      image,
      markers,
      activeMarkerId,
      viewportIsTabletOrBigger,
      isFlightDeck,
    } = this.props;

    return (
      <Waypoint
        onEnter={this.handleOnEnter}
        bottomOffset={this.inViewportMargin}
      >
        <div
          className={imageMapStyles.container}
          onClick={(evt) => this.maybeCloseActiveTooltip(evt)}
        >
          <div className={imageMapStyles.content}>
            {markers.map((props, index) => (
              <div
                className={classNames(imageMapStyles.marker, {
                  [imageMapStyles.markerAnimateIn]: isInViewport,
                  [imageMapStyles.markerIsActive]: this.isActive(props.id),
                })}
                key={index}
                onClick={() => this.toggleTooltip(props.id)}
                style={this.getMarkerStyles(props.markerStyles, index)}
              >
                <div
                  className={classNames(imageMapStyles.markerIcon, {
                    [imageMapStyles.markerIconActive]: this.isActive(props.id),
                  })}
                >
                  {viewportIsTabletOrBigger && (
                    <IconClose
                      width={18}
                      className={classNames(imageMapStyles.iconClose, {
                        [imageMapStyles.iconCloseIsActive]: this.isActive(
                          props.id
                        ),
                      })}
                      isLight
                    />
                  )}
                </div>
                {viewportIsTabletOrBigger && (
                  <Tooltip
                    isActive={this.isActive(props.id)}
                    {...props.tooltip}
                  />
                )}
              </div>
            ))}
            <Photo
              src={image.src}
              srcSet={image.srcSet}
              isFullWidth
              alt=""
              ref={this.photoRef}
            />
          </div>

          {!viewportIsTabletOrBigger && (
            <ImageMapSlider
              markers={markers}
              activeMarkerId={activeMarkerId}
              onChange={this.handleImageMapSliderChange}
              isFlightDeck={isFlightDeck}
            />
          )}
        </div>
      </Waypoint>
    );
  }
}
